import React from 'react';
import classnames from 'classnames';
import { twMerge } from 'tailwind-merge';

import Icon from 'components/Misc/Icon';

const Element = ({ name, value, option, onChange, readOnly }) => {
	// Concat classnames
	const cls = twMerge(
		'appearance-none rounded-lg flex items-center h-9 px-4 border border-neutral-200 text-neutral-600 ring-offset-2 focus:ring focus:ring-neutral-200 transition-all dark:ring-neutral-600 dark:border-neutral-700 dark:text-neutral-300 dark:ring-offset-neutral-800 disabled:cursor-not-allowed',
		value === option.value && 'bg-neutral-200 border-neutral-200 text-neutral-700 dark:bg-neutral-600 dark:border-neutral-600'
	);

	// Handle click on type
	const onClick = (event) => {
		event.preventDefault();
		onChange({ name, value: option.value });
	};

	return (
		<button className={cls} onClick={onClick} disabled={readOnly}>
			<Icon icon={option.icon} className="font-normal text-xl mr-3" />
			{option.text}
		</button>
	);
};

export default Element;